import { TableTitle, TableHead as UITableHead } from '@genial/components';
import React from 'react';

import { tableHeadAlignments, dataContent, TableHeadContentType } from '../../constants';

interface TableHeadProps {
  viewportType: 'tablet' | 'desktop';
  contentType: TableHeadContentType;
}

export const TableHead: React.FC<TableHeadProps> = ({ viewportType, contentType }) => {
  const { tableHead, widthCols } = dataContent[contentType];

  const items = Object.entries(tableHead);

  const Content = items.map((item, index) => (
    <TableTitle
      key={item[0]}
      testID={`table-head-title-${index}`}
      width={widthCols[item[0]][viewportType]}
      textAlign={tableHeadAlignments[item[0]]}>
      {item[1] as string}
    </TableTitle>
  ));

  return (
    <UITableHead display={{ base: 'none', lg: 'flex' }} testID="table-statements-head">
      {Content}
    </UITableHead>
  );
};
